import React, {Component, Fragment, useState} from "react";
import PageHelmet from "../component/common/Helmet";
import Breadcrumb from "../elements/common/Breadcrumb";
import CounterOne from "../elements/counters/CounterOne";
import ScrollToTop from 'react-scroll-up';
import {FiChevronUp} from "react-icons/fi";
import Header from "../component/header/Header";
import FooterThree from "../component/footer/FooterThree";
import {Link} from "react-router-dom";

class AddAbout extends Component {
    render() {
        return (
            <Fragment>
                <PageHelmet pageTitle='Дополнительные сведения'/>
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png"/>
                <Breadcrumb title={'Дополнительные сведения'}/>
                <div className="rn-team-area bg_color--1 ptb--80">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center mb--25">
                                    <h2 className="title">Полное наименование:</h2>
                                    <p className="description">Общество с ограниченной ответственностью «Неодинамика»</p>
                                </div>
                                <div className="section-title text-center mb--25">
                                    <h2 className="title">Сокращённое наименование:</h2>
                                    <p className="description">ООО «Неодинамика»</p>
                                </div>
                                <div className="section-title text-center mb--25">
                                    <h2 className="title">Юридический адрес:</h2>
                                    <p className="description">236022, Калининградская область, г. Калининград, ул. Шиллера, д. 7, литер Б</p>
                                </div>
                                <div className="section-title text-center mb--25">
                                    <h2 className="title">ИНН:</h2>
                                    <p className="description">3906219044</p>
                                </div>
                                <div className="section-title text-center mb--25">
                                    <h2 className="title">ОГРН:</h2>
                                    <p className="description">1103925015930</p>
                                </div>
                                <div className="section-title text-center mb--25">
                                    <h2 className="title">Основной ОКВЭД:</h2>
                                    <p className="description">63.11.1 — Деятельность по созданию и использованию баз данных и информационных ресурсов</p>
                                </div>
                                <div className="section-title text-center mb--25">
                                    <h2 className="title">Используемые технологии разработки:</h2>
                                    <p className="description">В рамках оказания услуг по разработке, доработке и сопровождению программного обеспечения компания использует современные технологии и инструменты разработки программных продуктов.</p>
                                </div>
                                <div className="section-title text-center mb--25">
                                    <h2 className="title">Стек технологий:</h2>
                                    <p className="description">Языки программирования: C++, C#<br/>
                                                               Платформа разработки: Unity<br/>
                                                               Базы данных: MySQL, PostgreSQL, ClickHouse</p>
                                </div>
                                <div className="section-title text-center mb--25">
                                    <h2 className="title">Контактное лицо:</h2>
                                    <p className="description">Александр Язынин</p>
                                </div>
                                <div className="section-title text-center mb--25">
                                    <h2 className="title">Телефон:</h2>
                                    <p className="description">+7 981 467-24-84</p>
                                </div>
                                <div className="section-title text-center mb--25">
                                    <h2 className="title">Дополнительный телефон:</h2>
                                    <p className="description">+7 921 614-84-78</p>
                                </div>
                                <div className="section-title text-center mb--25">
                                    <h2 className="title">E-mail:</h2>
                                    <p className="description"><a href="mailto:contact@neodinamika.com">contact@neodinamika.com</a></p>
                                </div>
                                <div className="section-title text-center mb--25">
                                    <h2 className="title">Виды деятельности в области информационных технологий:</h2>
                                    <p className="description">
                                        Коды видов деятельности в области информационных технологий в соответствии с Приказом Минцифры России №449:<br/>
                                        1.01 — Проектирование и разработка программного обеспечения<br/>
                                        22.01 — Деятельность по созданию видеоигр<br/>
                                    </p>
                                </div>
                                <div className="section-title text-center mb--25">
                                    <h2 className="title">Государственная аккредитация ИТ-компании:</h2>
                                    <p className="description"><a href="./2022_04_08_Подтверждение_об_аккредитации_НеоДинамики.pdf" target="_blank" type="application/pdf" rel="alternate" media="print">«Подтверждение государственной аккредитации ИТ-компании»</a></p>
                                </div>
                                <div className="section-title text-center mb--25">
                                    <h2 className="title">Стоимость услуг:</h2>
                                    <p className="description">
                                        Стоимость услуг определяется индивидуально в зависимости от объема, 
                                        состава и сроков работ и устанавливается на основании технического задания и договора с заказчиком. 
                                        Отдельные сведения могут составлять коммерческую тайну в соответствии с законодательством Российской Федерации
                                    </p>
                                </div>
                                <div className="section-title text-center mb--50">
                                    <h2 className="title">Правообладание:</h2>
                                    <p className="description">
                                        Компания не является правообладателем программного обеспечения и игр, упомянутых на сайте.<br/>
                                        Исключительные права на соответствующие программные продукты переданы правообладателям.<br/>
                                        Компания оказывает услуги по техническому и продуктовому сопровождению на основании договоров.
                                    </p>
                                </div>

                                <div className="section-title text-center">
                                    <p className="description">
                                        Информация на данной странице размещена в целях соблюдения требований к официальным сайтам аккредитованных организаций,
                                        осуществляющих деятельность в области информационных технологий,
                                        в соответствии с приказом Министерства цифрового развития, связи и массовых коммуникаций Российской Федерации.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp/>
                    </ScrollToTop>
                </div>
                <FooterThree/>
            </Fragment>
        )
    }
}

export default AddAbout